import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue2Filters from 'vue2-filters'

import App from './App.vue'

import HomePage from './components/HomePage.vue'
import ListPage from './components/ListPage.vue'

import NotFound from './components/NotFound.vue'

Vue.config.productionTip = false

// Import CSS
import "@/assets/global.css"

import vuetify from './plugins/vuetify';

Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(Vue2Filters)

const routes = [
  { path: '/', component: HomePage },
  { path: '/list/', component: ListPage },
  { path: '/list/:listId', component: ListPage, props: true },
  { path: '*', component: NotFound },
]

const router = new VueRouter({
    routes
})

new Vue({
    el: "#app",
    router,
    vuetify,
    render: h => h(App)
})

